import React from "react";

import Users from "./Users";
import UsersBySubscription from "../UsersBySubscription/UsersBySubscription";
import { checkCustomerAdmin } from "./services/UserService";

export const UserContainer: React.FunctionComponent = () =>
  checkCustomerAdmin() ? <UsersBySubscription /> : <Users />;
UserContainer.displayName = "UserContainer";
